import { useIsDisabled } from "@superwall/legacy-ui"
import { FieldRenderProps, UseFieldConfig, useField } from "react-final-form"

export function useEnhancedField<FieldValue = any, T extends HTMLElement = HTMLElement>(
  name: string,
  config?: UseFieldConfig<FieldValue>
): FieldRenderProps<FieldValue, T> & { extra: { isDisabled: boolean } } {
  const { isDisabled } = useIsDisabled()
  return { ...useField(name, config), extra: { isDisabled } }
}

// export const useEnhancedField = useField
